import FacebookAuth from "../../components/FacebookAuth";
import GoogleAuth from "../../components/GoogleAuth";
import EmailIcon from "@/assets/images/icons/email.svg?inline";
import PhoneIcon from "@/assets/images/icons/phone.svg?inline";

export default {
  name: "registration-options",

  data() {
    return {};
  },

  props: {
    isSocialAuth: {
      type: Boolean,
      default: true
    },
    initialText: {
      type: Object,
      default: {
        h3: 'Sign up for personalized results',
        h6: null
      }
    }
  },

  // mounted: function() {},

  methods: {
    initRegistration() {
      this.$emit("initRegistration");
    }
  },

  components: {
    FacebookAuth,
    GoogleAuth,
    EmailIcon,
    PhoneIcon
  }
};
